import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScale = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 82,
	height: 72,
	viewBox: "0 0 82 72",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M75.5346 2.21204H6.4361C4.10148 2.21204 2.21198 4.10153 2.21198 6.43615V8.45283C2.21198 10.7875 4.10148 12.6769 6.4361 12.6769H10.524L13.44 22.6377C13.9123 24.2456 15.384 25.3493 17.06 25.3493H28.8785V32.98H17.06C15.384 32.98 13.9123 34.0837 13.44 35.6916L6.84034 58.2203C6.13178 60.6366 7.94406 63.053 10.4604 63.053H15.3567V67.7495C15.3567 68.4626 15.9336 69.044 16.6512 69.044H25.4129C26.126 69.044 26.7073 68.4672 26.7073 67.7495V63.053H55.2679V67.7495C55.2679 68.4626 55.8447 69.044 56.5624 69.044H65.324C66.0371 69.044 66.6185 68.4672 66.6185 67.7495V63.053H71.5148C74.0311 63.053 75.8434 60.6366 75.1349 58.2203L68.5352 35.6916C68.0629 34.0837 66.5912 32.98 64.9152 32.98H53.0968V25.3493H64.9152C66.5912 25.3493 68.0629 24.2456 68.5352 22.6377L71.4513 12.6769H75.5391C77.8737 12.6769 79.7632 10.7875 79.7632 8.45283V6.43615C79.7632 4.10153 77.8737 2.21204 75.5391 2.21204H75.5346Z",
			stroke: "white",
			strokeWidth: 4.42397,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.3567 61.6676H26.7028V67.7494C26.7028 68.4625 26.1214 69.0439 25.4083 69.0439H16.6467C15.9336 69.0439 15.3522 68.4625 15.3522 67.7494V61.6676H15.3567Z",
			fill: "url(#paint0_linear_43_284)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.2678 61.6676H66.6139V67.7494C66.6139 68.4625 66.0325 69.0439 65.3194 69.0439H56.5578C55.8447 69.0439 55.2633 68.4625 55.2633 67.7494V61.6676H55.2678Z",
			fill: "url(#paint1_linear_43_284)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.0922 20.8752H28.883V37.5174H53.0922V20.8752Z",
			fill: "url(#paint2_linear_43_284)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.93878 7.25818L13.4445 22.6422C13.9169 24.25 15.3885 25.3538 17.0645 25.3538H64.9152C66.5912 25.3538 68.0629 24.25 68.5352 22.6422L73.041 7.25818H8.93878Z",
			fill: "url(#paint3_linear_43_284)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.5346 2.21204H6.4361C4.10318 2.21204 2.21198 4.10323 2.21198 6.43615V8.45283C2.21198 10.7858 4.10318 12.6769 6.4361 12.6769H75.5346C77.8675 12.6769 79.7587 10.7858 79.7587 8.45283V6.43615C79.7587 4.10323 77.8675 2.21204 75.5346 2.21204Z",
			fill: "url(#paint4_linear_43_284)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.5103 63.0529H10.4604C7.94405 63.0529 6.13177 60.6365 6.84033 58.2201L13.44 35.6915C13.9123 34.0836 15.384 32.9799 17.06 32.9799H64.9107C66.5867 32.9799 68.0583 34.0836 68.5307 35.6915L75.1303 58.2201C75.8389 60.6365 74.0266 63.0529 71.5103 63.0529Z",
			fill: "url(#paint5_linear_43_284)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.9465 51.2436L19.3628 42.9997C19.758 41.6462 21.0025 40.7151 22.4151 40.7151H59.5647C60.9773 40.7151 62.2218 41.6462 62.6169 42.9997L65.0333 51.2436C65.6283 53.2784 64.1022 55.3178 61.9811 55.3178H19.9987C17.8776 55.3178 16.3514 53.2784 16.9465 51.2436Z",
			fill: "url(#paint6_linear_43_284)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.9876 42.2003L40.2064 53.3965H41.7643L40.9876 42.2003Z",
			fill: "#303651"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.0876 55.3178C46.9968 52.0248 44.2988 49.3859 40.9876 49.3859C37.6765 49.3859 34.9785 52.0248 34.8876 55.3178H47.0922H47.0876Z",
			fill: "#98A4A6"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_43_284",
				x1: 21.0343,
				y1: 61.7312,
				x2: 21.0343,
				y2: 69.698,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .18,
						stopColor: "#40201C"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .55,
						stopColor: "#633328"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .92,
						stopColor: "#8B4A37"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_43_284",
				x1: 60.9409,
				y1: 61.7312,
				x2: 60.9409,
				y2: 69.698,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .18,
						stopColor: "#40201C"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .55,
						stopColor: "#633328"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .92,
						stopColor: "#8B4A37"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_43_284",
				x1: -899337e-11,
				y1: 24.6588,
				x2: 40.9876,
				y2: 32.1487,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#F2D455" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .15,
						stopColor: "#EBBA4A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .39,
						stopColor: "#E1973B"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .62,
						stopColor: "#DB7E31"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .83,
						stopColor: "#D76F2B"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#D66A29"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_43_284",
				x1: 40.9876,
				y1: 24.9086,
				x2: 40.9876,
				y2: 7.74872,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#D7E8EA" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .26,
						stopColor: "#D3E4E6"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .49,
						stopColor: "#C9D9DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .72,
						stopColor: "#B8C6C8"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .94,
						stopColor: "#A0ACAE"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#98A4A6"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_43_284",
				x1: 17.1917,
				y1: -22.0789,
				x2: 85.0365,
				y2: 62.1174,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#D7E8EA" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .26,
						stopColor: "#D3E4E6"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .49,
						stopColor: "#C9D9DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .72,
						stopColor: "#B8C6C8"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .94,
						stopColor: "#A0ACAE"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#98A4A6"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_43_284",
				x1: 23.8595,
				y1: 34.1926,
				x2: 100.484,
				y2: 110.813,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#F2D455" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .15,
						stopColor: "#EBBA4A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .39,
						stopColor: "#E1973B"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .62,
						stopColor: "#DB7E31"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .83,
						stopColor: "#D76F2B"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#D66A29"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint6_linear_43_284",
				x1: 23.9685,
				y1: 28.3925,
				x2: 71.7647,
				y2: 87.7164,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#D7E8EA" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .26,
						stopColor: "#D3E4E6"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .49,
						stopColor: "#C9D9DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .72,
						stopColor: "#B8C6C8"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .94,
						stopColor: "#A0ACAE"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#98A4A6"
					})
				]
			})
		] })
	]
});
export default SvgScale;
